import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import HocPopup from "../../../../hoc/hocPopup";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  useTheme,
  Typography,
  Tooltip,
} from "@mui/material";
import { useAuth } from "../../../../context/Auth.context";
import {
  TYPE,
  appUrl,
  capitalizeFirstLetter,
  today,
} from "../../../../utils/Utils";
import {
  ContentCopy,
  Edit,
  QrCodeScannerOutlined,
  Refresh,
} from "@mui/icons-material";
import GroupIcon from "@mui/icons-material/Group";
import BreadcrumbsComponent from "../../../base/Breadcrumbs.component";
import DealershipStyles from "./Dealership.styles";
import { useQuery, useSubscription } from "@apollo/client";
import { GET_CALL_COUNT } from "../../../../graphql/query/query";
import { useAppContext } from "../../../../context/App.context";
import moment from "moment";
import InformationDialog from "../../../base/dialog-body/Information.dialog";
import { InputValidation } from "../../../../utils/InputValidationRegex";
import { useParams } from "react-router-dom";
import AddNewUserComponent from "./AddNewUser.component";
import { ON_EMPLOYEE_UPDATE } from "../../../../graphql/subscription/subscription";
import { GET_DEALERSHIPS } from "../../../../graphql/query/query";
import Theme from "../../../../utils/Theme";
import { MnageUsersQRStyle, QRPageStyle } from "../../../../utils/Styles.utils";
import { useReactToPrint } from "react-to-print";
import QRCodeUtils from "../../../../utils/qrcode";
import ManageUsersTable from "../../../../utils/ManageusersTable";

const INITIAL_FILTER = {
  startDate: moment(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  ).format("MM/DD/YYYY"),
  endDate: moment(new Date()).format("MM/DD/YYYY"),
};

const DealershipUserComponent = ({ dialog, isAdminModule = true }) => {
  let breadcrumb;

  const auth = useAuth();
  const theme = useTheme();
  const params = useParams();
  const app = useAppContext();
  const [dealership, setDealership] = useState();
  const [editUser, setEditUser] = useState(null);
  const [printUser, setPrintUser] = useState(null);

  useEffect(() => {
    if (app?.dealerships) {
      setDealership(app?.dealerships?.dealerships[0]);
    }
  }, [app]);

  if (isAdminModule) {
    breadcrumb = {
      title: `${dealership?.full_name} Users`,
      links: [
        { path: "/", name: "Dealership" },
        {
          path: `/dealerships/${params.dealershipId}`,
          name: `${dealership?.full_name} Details`,
        },
        { path: null, name: `${dealership?.full_name} Users` },
      ],
    };
  } else {
    breadcrumb = {
      title: "Manage User",
      links: [
        { path: "/", name: "Home" },
        { path: null, name: "Manage User" },
      ],
    };
  }
  const [filterData, setFilterData] = useState(INITIAL_FILTER);
  const [fetchInput, setFetchInput] = useState({
    d_startDate: moment(filterData.startDate).format("YYYY-MM-DD"),
    d_endDate: moment(filterData.endDate).format("YYYY-MM-DD"),
    dealership_id: params.dealershipId || auth?.user?.dealership_id,
    timezone: new Date().getTimezoneOffset(),
    isAdmin: true,
  });

  const { loading, data, refetch } = useQuery(GET_CALL_COUNT, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    variables: {
      callInput: fetchInput,
    },
  });
  const { data: OnEmployeeUpdate } = useSubscription(ON_EMPLOYEE_UPDATE, {
    variables: {
      dealership_id: params.dealershipId || auth?.user?.dealership_id,
    },
  });

  const TableDataHandler = (response) => {
    let newData = response.employee.filter(
      (person) => person.employee_user_id !== auth.user.user_id
    );
    let managers = newData.filter((person) => person.role === "manager");
    let employees = newData.filter((person) => person.role === "employee");
    app.setTarget([]);
    app.setTarget([...managers, ...employees]);
  };

  useLayoutEffect(() => {
    if (data) {
      if (data?.getEmployeeTarget?.errors) {
        dialog({
          open: true,
          bodyType: TYPE.DEFAULT,
          body: (
            <InformationDialog
              text={data.getEmployeeTarget.errors[0].message}
            />
          ),
        });
      } else if (OnEmployeeUpdate) {
        console.log(
          "OnEmployeeUpdate",
          OnEmployeeUpdate?.onEmployeeUpdate?.employee_details
        );
        TableDataHandler(OnEmployeeUpdate?.onEmployeeUpdate?.employee_details);
      } else {
        console.log("OnEmployeeUpdateData", data?.getEmployeeTarget);
        TableDataHandler(data?.getEmployeeTarget);
      }
    }
  }, [data, OnEmployeeUpdate]);
  const [refreshChild, setRefreshChild] = useState(false);

  const handleButtonClick = () => {
    setRefreshChild(true);
  };

  const getWorkFlowDetails = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });
  console.log("getWorkFlowDetails", getWorkFlowDetails);

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: QRPageStyle,
  });

  const input = {
    dealership: app?.dealerships?.dealerships[0],
    employees: app?.target,
    refetch: refetch,
    breadcrumb: breadcrumb,
    isAdminModule: true,
    dialog: dialog,
  };
  console.log("dealersship", input?.dealership);
  return <ManageUsersTable input={input} />;
};

export default HocPopup(DealershipUserComponent);
